import React from 'react'
import { useIntl } from 'react-intl'
import PageContainer from 'Components/PageContainer'
import { EmptyState, SpacingVertical, SPACING_40 } from 'mailup-web-components'
import emptyStateImg from 'mailup-web-components/resources/mailup-web-app/img/svg/empty-state_access-denied.svg'

const NoAuthPage = () => {
  const intl = useIntl()

  return (
    <PageContainer>
      <SpacingVertical variant={SPACING_40} />
      <EmptyState
        data-mu-test='access-denied'
        title={intl.formatMessage({ id: 'Load.NoAuthPage.Title' })}
        description={intl.formatMessage({
          id: 'Load.NoAuthPage.Description'
        })}
        thumbSrc={emptyStateImg}
      />
    </PageContainer>
  )
}

export default NoAuthPage
